var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProductIconBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 28
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h26v28H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1291d9",
  fillRule: "evenodd",
  d: "M13 14a3.5 3.5 0 1 1-3.429 3.5A3.475 3.475 0 0 1 13 14m0-10.5A3.475 3.475 0 0 0 9.571 7h6.857A3.475 3.475 0 0 0 13 3.5M21.571 28H4.429A3.475 3.475 0 0 1 1 24.5v-14A3.475 3.475 0 0 1 4.429 7h1.714A6.95 6.95 0 0 1 13 0a6.95 6.95 0 0 1 6.857 7h1.714A3.475 3.475 0 0 1 25 10.5v14a3.475 3.475 0 0 1-3.429 3.5"
})));
export { SvgProductIconBlue as ReactComponent };
export default __webpack_public_path__ + "static/media/product_icon_blue.978cbe5a.svg";